var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDubleArrowLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85355 2.64645C9.04882 2.84171 9.04882 3.15829 8.85355 3.35355L6.20711 6L8.85355 8.64645C9.04882 8.84171 9.04882 9.15829 8.85355 9.35355C8.65829 9.54882 8.34171 9.54882 8.14645 9.35355L5.14645 6.35355C4.95118 6.15829 4.95118 5.84171 5.14645 5.64645L8.14645 2.64645C8.34171 2.45118 8.65829 2.45118 8.85355 2.64645ZM5.85355 2.64645C6.04882 2.84171 6.04882 3.15829 5.85355 3.35355L3.20711 6L5.85355 8.64645C6.04882 8.84171 6.04882 9.15829 5.85355 9.35355C5.65829 9.54882 5.34171 9.54882 5.14645 9.35355L2.14645 6.35355C2.05268 6.25978 2 6.13261 2 6C2 5.86739 2.05268 5.74021 2.14645 5.64645L5.14645 2.64645C5.34171 2.45118 5.65829 2.45118 5.85355 2.64645Z",
    fill: "#494C5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDubleArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dubleArrowLeft.908226b0cb89a62ad61c68ade518fe57.svg";